<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i7c66T/tc-custom/9781452125169.jpg?1726454431680" alt="This image is the cover for the book Party Appetizers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Party Appetizers
      </h1>
      <p class="bookDescription body article font2">
        <b>The entertaining expert and Food Network host shares nearly fifty fun and creative recipes for irresistible party bites, finger foods, small plates, and more.</b><br/><br/>Entertaining aficionado Tori Ritchie serves up sensational recipes for fabulous finger foods. From cocktail parties and holiday soirees to impromptu gatherings with friends, they’re perfect for any celebration. Welcome your guests with salty starters like Spiked Olives or Curry Cashews. Keep the party rolling with fabulous finger foods such as savory Salt-Roasted Prawns with Lemon Pesto, rich Fig and Gorgonzola Crostini with Caramelized Onions, and colorful Cherry Tomatoes Stuffed with Avocado and Bacon. <br/><br/>For guests who seek sweets, there are even a few bon-bons such as Mocha Shortbread and Sugar and Spice Walnuts. Tori’s tips on smart shopping, artful presentation, and essential ingredients, along with make-ahead strategies will make planning and preparing a snap. So let the festivities begin!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tori Ritchie, Victoria Pearson
      </h2>
      
      <p class="authorDescription body article">Tori Ritchie is a San Francisco based food writer, cooking teacher, and host of Food Network's Ultimate Kitchens . She is the former food and wine editor for San Francisco magazine and the author of several cookbooks. Her articles have appeared in Bon Appetit and the San Francisco Chronicle among other publications.Victoria Pearson is a Los Angeles based photographer. Her photographs have appeared in several books including Sangria (0-8118-4290-8), Party Appetizers (0-8118-4292-4), and The Cheese Course (0-8118-2541-8).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?efd7da46